import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { Check, Send, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ConsultForm({ source = "Website" }) {
  const { t, lang } = useLang();
  const f = t.contactForm;
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    first: "",
    last: "",
    company: "",
    email: "",
    phone: "",
    message: "",
    consent: false,
  });

  const upd = (k) => (e) =>
    setForm((p) => ({ ...p, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, source, lang }),
      });
      if (!res.ok) throw new Error("request failed");
      setSent(true);
      setForm({ first: "", last: "", company: "", email: "", phone: "", message: "", consent: false });
    } catch (err) {
      setError(lang === "ar" ? "تعذّر الإرسال. حاول مرة أخرى." : "Could not send. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl bg-white border border-[rgba(10,31,60,0.14)] px-4 py-3 text-sm text-[color:var(--rq-navy)] placeholder:text-[color:var(--rq-muted)] outline-none transition-colors duration-300 focus:border-[color:var(--rq-green)]";

  if (sent) {
    return (
      <div className="rq-card p-10 text-center flex flex-col items-center justify-center min-h-[420px]" data-testid="consult-form-success">
        <div className="grid place-items-center h-16 w-16 rounded-full bg-[rgba(46,230,110,0.15)] mb-5">
          <Check size={32} className="text-[color:var(--rq-green)]" />
        </div>
        <p className="text-lg font-semibold text-white">{f.success}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="rq-card p-6 md:p-8" data-testid="consult-form">
      <h3 className="font-display text-xl font-bold text-white mb-6">{f.title}</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <input required className={inputCls} placeholder={f.first} value={form.first} onChange={upd("first")} data-testid="consult-first-input" />
        <input required className={inputCls} placeholder={f.last} value={form.last} onChange={upd("last")} data-testid="consult-last-input" />
        <input className={inputCls} placeholder={f.company} value={form.company} onChange={upd("company")} data-testid="consult-company-input" />
        <input required type="email" className={inputCls} placeholder={f.email} value={form.email} onChange={upd("email")} data-testid="consult-email-input" />
        <input className={`${inputCls} sm:col-span-2`} placeholder={f.phone} value={form.phone} onChange={upd("phone")} data-testid="consult-phone-input" />
        <textarea rows={4} className={`${inputCls} sm:col-span-2 resize-none`} placeholder={f.message} value={form.message} onChange={upd("message")} data-testid="consult-message-input" />
      </div>
      <label className="mt-4 flex items-center gap-2 text-xs text-[color:var(--rq-muted)] cursor-pointer">
        <input required type="checkbox" checked={form.consent} onChange={upd("consent")} className="accent-[color:var(--rq-green)] h-4 w-4" data-testid="consult-consent-checkbox" />
        {f.consent}
      </label>
      {error && (
        <p className="mt-3 text-sm text-red-400" data-testid="consult-form-error">{error}</p>
      )}
      <button type="submit" disabled={loading} className="rq-glow-btn mt-6 w-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="consult-submit-button">
        {loading ? (
          <>
            {lang === "ar" ? "جارٍ الإرسال..." : "Sending..."}
            <Loader2 size={16} className="animate-spin" />
          </>
        ) : (
          <>
            {f.submit}
            <Send size={16} />
          </>
        )}
      </button>
    </form>
  );
}
